const headerPack = {
  '& :is(h1, h2, h3, h4)': {
    fontWeight: 'bold',
  },

  '& h1': {
    fontSize: '2em',
    my: '0.67em',
  },

  '& h2': {
    fontSize: '1.5em',
    my: '0.83em',
  },

  '& h3': {
    fontSize: '1.17em',
    my: '1em',
  },

  '& h4': {
    my: '1.33em',
  },
};

export default headerPack;
